import actions from '../action/city'
import CONSTANT from '../constant/city'
import CCONSTANT from '../constant/cookie'
import cookie from '../lib/cookie'
import { setCustomizedHeader } from '../util/x_client_info'
import op from 'object-path'
import localStorage from 'localStorage'
import _ from 'underscore'

const cityList = []
const locate = {}
const cakeStoreCitys = []
const cakeStore = []
const defaultGPSAddress = {
  cityId: 440300,
  cityName: '深圳',
  name: ''
}

export default {
  actions,
  state: {
    cityList,
    locate,
    selected: {
      cityId: 0,
      name: ''
    },
    gps: {
      latitude: 0,
      longitude: 0
    },
    selectCity: {
      cityId: 0,
      cityName: ''
    },
    localAddress: JSON.parse(localStorage.getItem(CCONSTANT.COOKIE_DEFAULT_SHIPPING_ADDRESS)) || {},
    selectedAddress: JSON.parse(localStorage.getItem(CCONSTANT.COOKIE_USER_SELECT_SHIPPING_ADDRESS)) || {},
    cakeStoreCitys,
    cakeStore,
    cityCenterLocation: {}, //城市中心点经纬度
  },
  mutations: {
    [CONSTANT.CAKESTORECITY_GET_LIST_SUCCESS](state, res) {
      state.cakeStoreCitys = res.list || []
    },
    [CONSTANT.CAKESTORECITY_GET_LIST_ERROR](state, e) {
      return state.cakeStoreCitys = []
    },
    [CONSTANT.CAKESTORE_GET_LIST_SUCCESS](state, res) {
      state.cakeStore = res.list || []
    },
    [CONSTANT.CAKESTORE_GET_LIST_ERROR](state, e) {
      return state.cakeStore = []
    },

    [CONSTANT.CITY_CHANGE_SELECTED](state, city) {
      state.selected = city
      cookie(CCONSTANT.COOKIE_V2_CITY_ID, city.cityId)
      cookie(CCONSTANT.COOKIE_V2_CITY_NAME, city.name)
      setCustomizedHeader({ bc: `${city.cityId}` })
    },
    [CONSTANT.CITY_GET_LIST_SUCCESS](state, data) {
      return (state.cityList = data.cities || [])
    },
    [CONSTANT.CITY_GET_LIST_ERROR](state, e) {
      return (state.cityList = [])
    },

    [CONSTANT.CITY_GET_LOCATE_SUCCESS](state, data) {
      state.locate = data.city || {}
      cookie(CCONSTANT.COOKIE_LOCAL_CITY_ID, data.city.cityId)
      cookie(CCONSTANT.COOKIE_LOCAL_CITY_NAME, data.city.name)
    },
    [CONSTANT.CITY_GET_LOCATE_ERROR](state, e) {
      return (state.locate = {})
    },
    [CONSTANT.CITY_SET_GPS_POSITION](state, { latitude, longitude }) {
      state.gps = {
        latitude,
        longitude
      }
      setCustomizedHeader({la: latitude, lo: longitude})
    },
    // 定位成功， 更新缓存和state
    [CONSTANT.CITY_GET_LOCATE_ADDRESS_SUCCESS](state, data) {
      state.localAddress = data
      localStorage.setItem(CCONSTANT.COOKIE_DEFAULT_SHIPPING_ADDRESS, JSON.stringify(data))
    },
    [CONSTANT.CITY_GET_LOCATE_ADDRESS_ERROR](state, e) {
      state.selectedAddress = {}
      state.localAddress = {}
      localStorage.removeItem(CCONSTANT.COOKIE_DEFAULT_SHIPPING_ADDRESS)
    },
    [CONSTANT.CITY_CHANGE_SHIPPING_ADDRESS](state, data) {
      state.selectedAddress = {name: '', ...data}
      localStorage.setItem(CCONSTANT.COOKIE_USER_SELECT_SHIPPING_ADDRESS, JSON.stringify(state.selectedAddress))
      setCustomizedHeader({ bl: `${data.addressId || 0}` })
    },
    [CONSTANT.CITY_CHANGE_SHIPPING_CITY](state, data) {
      state.selectCity = {
        cityId: data.cityId,
        cityName: data.cityName
      }
    },
    [CONSTANT.CITY_SET_CITY_CENTER_LOCATION](state, data) {
      state.cityCenterLocation = data
    }
  },
  getters: {
    cityGetSelectedCity: state => {
      // 用户最新选择的城市 > 用户历史选择的城市 > 用户当前定位的城市 > 用户历史定位保存到的城市 > 系统默认的城市
      const ret = {
        cityId:
          +state.selected.cityId ||
          +cookie(CCONSTANT.COOKIE_V2_CITY_ID) ||
          +state.locate.cityId ||
          +cookie(CCONSTANT.COOKIE_LOCAL_CITY_ID) ||
          CONSTANT.DEFAULT_CITY_ID,
        name:
          state.selected.name ||
          cookie(CCONSTANT.COOKIE_V2_CITY_NAME) ||
          state.locate.name ||
          cookie(CCONSTANT.COOKIE_LOCAL_CITY_NAME) ||
          CONSTANT.DEFAULT_CITY_NAME
      }
      return { ...ret }
    },
    // 用户选择位置 > 定位缓存 > 默认定位
    cityGetAddress: state => {
      const addressInfo =
        !_.isEmpty(state.selectedAddress) && state.selectedAddress ||
        JSON.parse(localStorage.getItem(CCONSTANT.COOKIE_USER_SELECT_SHIPPING_ADDRESS)) ||
        JSON.parse(localStorage.getItem(CCONSTANT.COOKIE_DEFAULT_SHIPPING_ADDRESS))
      return { ...addressInfo }
    },
    getGPSPostion: state => {
      return state.gps
    },
    // 用户选择城市 > 定位缓存城市 > 默认定位城市
    getCityByPoipicker: state => {
      return {
        cityId:
          state.selectCity.cityId ||
          op.get(JSON.parse(localStorage.getItem(CCONSTANT.COOKIE_USER_SELECT_SHIPPING_ADDRESS)), 'cityId') ||
          op.get(JSON.parse(localStorage.getItem(CCONSTANT.COOKIE_DEFAULT_SHIPPING_ADDRESS)), 'cityId')
        ,
        cityName:
          state.selectCity.cityName ||
          op.get(JSON.parse(localStorage.getItem(CCONSTANT.COOKIE_USER_SELECT_SHIPPING_ADDRESS)), 'cityName') ||
          op.get(JSON.parse(localStorage.getItem(CCONSTANT.COOKIE_DEFAULT_SHIPPING_ADDRESS)), 'cityName')
        }
    }
  }
}
